import React from 'react';
import { VOICE_ACTIVE_COLOR, VOICE_BARS } from './FooterVoice.constants';

const VoiceWaveform = ({ progress = 0, isDarkMode, activeColor = VOICE_ACTIVE_COLOR }) => (
    <div
        aria-hidden="true"
        style={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            height: 32,
            minWidth: 0,
            flex: 1
        }}
    >
        {VOICE_BARS.map((height, index) => {
            const isActive = (progress / 100) * VOICE_BARS.length > index;
            return (
                <div
                    key={index}
                    style={{
                        width: 3,
                        flex: '1 1 3px',
                        maxWidth: 4,
                        minWidth: 2,
                        height: `${height}%`,
                        borderRadius: 4,
                        background: isActive
                            ? activeColor
                            : isDarkMode ? 'rgba(255, 255, 255, 0.22)' : '#d9e1ea'
                    }}
                />
            );
        })}
    </div>
);

export default VoiceWaveform;
